module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/path.js
// module id = 23
// module chunks = 0